import { useState } from "react";
import { Share2, Copy, MessageCircle, MessageSquare, Instagram, Linkedin } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const copy = async (text, msg) => {
  await navigator.clipboard.writeText(text);
  toast.success(msg);
};

export const ShareJob = ({ id, title, text, url }) => {
  const [open, setOpen] = useState(false);
  const message = `${text} ${url}`;
  const enc = encodeURIComponent(message);

  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url }); } catch (_) {}
      return;
    }
    setOpen(true);
  };

  const options = [
    { Icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/?text=${enc}` },
    { Icon: MessageSquare, label: "Text message", href: `sms:?&body=${enc}` },
    { Icon: Instagram, label: "Instagram", action: () => copy(message, "Link copied — paste it in your Instagram story or DM") },
    { Icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}` },
    { Icon: Copy, label: "Copy link", action: () => copy(url, "Job link copied") },
  ];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => { e.preventDefault(); share(); }} aria-label={`Share ${title}`} data-testid={`career-share-${id}`}
          className="w-11 h-11 rounded-full border border-black/10 bg-white/70 flex items-center justify-center text-[var(--ink)] transition-all duration-300 hover:bg-[var(--ink)] hover:text-white hover:-translate-y-0.5">
          <Share2 size={18} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-60 p-2 rounded-2xl" data-testid={`career-share-menu-${id}`}>
        <p className="px-3 pt-1 pb-2 text-xs font-bold uppercase tracking-[0.18em] text-[var(--saffron)]">Join CreJik's mission</p>
        {options.map(({ Icon, label, href, action }) => {
          const cls = "w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-semibold text-[var(--ink)] hover:bg-black/5 transition-colors";
          return href ? (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" className={cls} onClick={() => setOpen(false)} data-testid={`career-share-${id}-${label.toLowerCase().replace(/\s+/g, "-")}`}><Icon size={16} /> {label}</a>
          ) : (
            <button key={label} type="button" className={cls} onClick={() => { action(); setOpen(false); }} data-testid={`career-share-${id}-${label.toLowerCase().replace(/\s+/g, "-")}`}><Icon size={16} /> {label}</button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
};
